import VenuesAPI from 'dashboard/api/venues';

const buildGeocodeQuery = ({ address, city, country } = {}) =>
  [address, city, country].map(part => part?.trim()).filter(Boolean).join(', ');

const isCanceledError = error =>
  error?.code === 'ERR_CANCELED' ||
  error?.code === 'GEOCODE_CANCELED' ||
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError';

const canceledError = () => {
  const error = new Error('GEOCODE_CANCELED');
  error.code = 'GEOCODE_CANCELED';
  return error;
};

// Nominatim: [south, north, west, east] → Leaflet: [[south, west], [north, east]]
const toLeafletBounds = boundingbox => {
  if (!Array.isArray(boundingbox) || boundingbox.length !== 4) return null;
  const [south, north, west, east] = boundingbox.map(Number);
  if ([south, north, west, east].some(value => Number.isNaN(value))) return null;
  return [
    [south, west],
    [north, east],
  ];
};

export const useVenueGeocode = () => {
  let lastQuery = '';
  let abortController = null;

  const geocodeLocation = async parts => {
    const query = buildGeocodeQuery(parts);
    if (!query || query === lastQuery) return null;

    if (abortController) abortController.abort();
    abortController = new AbortController();

    try {
      const response = await VenuesAPI.geocode(parts, {
        signal: abortController.signal,
      });
      const { latitude, longitude, boundingbox } = response.data || {};
      if (latitude == null || longitude == null) {
        const error = new Error('GEOCODE_NOT_FOUND');
        error.code = 'GEOCODE_NOT_FOUND';
        throw error;
      }

      lastQuery = query;
      return {
        latitude: Number(latitude),
        longitude: Number(longitude),
        bounds: toLeafletBounds(boundingbox),
      };
    } catch (error) {
      if (isCanceledError(error)) throw canceledError();
      // eslint-disable-next-line no-console
      console.warn('[venue geocode]', query, error);
      throw error;
    }
  };

  return { geocodeLocation, buildGeocodeQuery };
};
